// export const server = `http://localhost:3005`;
// export const server = `http://127.0.0.1:3005`;
// export const server = `http://34.19.41.170:3000`;
// export const server = `http://192.168.1.108:3005`;
// export const server = `http://136.109.196.233`;
export const server = `https://vermilionharbor.com`;
